import { render } from "./CreateWebhook.vue?vue&type=template&id=90dc2584&scoped=true"
import script from "./CreateWebhook.vue?vue&type=script&lang=js"
export * from "./CreateWebhook.vue?vue&type=script&lang=js"

import "./CreateWebhook.vue?vue&type=style&index=0&id=90dc2584&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90dc2584"]])

export default __exports__